export default __webpack_public_path__ + "assets/img/rostelecom.7addb54.svg";